export default __webpack_public_path__ + "static/media/tweet-sentiment.68bc5227.png";